import { render, staticRenderFns } from "./UiCrudCard.vue?vue&type=template&id=cdd7619a&"
import script from "./UiCrudCard.vue?vue&type=script&lang=js&"
export * from "./UiCrudCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports